<template>
	<div class="db-detail-root">
		<!-- 设备基础信息卡片 -->
		<el-row class="info-card">
			<el-row class="info-header">
				<el-col :span="11">
					<el-row>
						<img :src="formObject.picUrl" class="device-img" v-if="formObject.picUrl" />
						<!-- 无图片时占位 -->
						<div class="img-placeholder" v-else>暂无图片</div>
					</el-row>
				</el-col>
				<el-col :span="13">
					<el-row class="device-name">{{formObject.deviceName || '-'}}</el-row>
					<el-row class="info-row">
						<el-col class="label-col">状态：</el-col>
						<el-col>
							<label class="status-offline" v-if="formObject.deviceStatus == 1">离线</label>
							<label class="status-online" v-if="formObject.deviceStatus == 2">在线</label>
							<label class="status-unknown" v-else>-</label>
						</el-col>
					</el-row>
					<el-row class="info-row">
						<el-col class="label-col">设备种类：</el-col>
						<el-col>
							<label v-if="formObject.deviceType == 1">电表</label>
							<label v-if="formObject.deviceType == 2">控制器</label>
							<label v-if="formObject.deviceType == 3">逆变器</label>
							<label v-else>-</label>
						</el-col>
					</el-row>
					<el-row class="info-row">
						<el-col class="label-col">设备地址：</el-col>
						<el-col :title="formObject.addresss" v-if="formObject.addresss">
							{{formObject.addresss}}
						</el-col>
						<el-col v-else>-</el-col>
					</el-row>
				</el-col>
			</el-row>
		</el-row>
		
		<!-- 电表核心数据卡片 -->
		<el-row class="data-card">
			<el-row class="data-row">
				<div class="data-item" v-if="formData.dyldy || formData.dyldy === 0">
					<div class="item-header">
						<div class="item-title">第一路电压</div>
						<div class="update-time">{{formData.uploadTime || '-'}}</div>
					</div>
					<div class="item-value">{{formData.dyldy}}V</div>
				</div>
				<div class="data-item" v-if="formData.zdl || formData.zdl === 0">
					<div class="item-header">
						<div class="item-title">总电流</div>
						<div class="update-time">{{formData.uploadTime || '-'}}</div>
					</div>
					<div class="item-value">{{formData.zdl}}A</div>
				</div>
				<div class="data-item" v-if="formData.address">
					<div class="item-header">
						<div class="item-title">设备地址</div>
						<div class="update-time">{{formData.uploadTime || '-'}}</div>
					</div>
					<div class="item-value">{{formData.address}}</div>
				</div>
				<div class="data-item" v-if="formData.zyggl || formData.zyggl === 0">
					<div class="item-header">
						<div class="item-title">总有功率</div>
						<div class="update-time">{{formData.uploadTime || '-'}}</div>
					</div>
					<div class="item-value">{{formData.zyggl}}kw</div>
				</div>
			</el-row>
			<el-row class="data-row">
				<div class="data-item" v-if="formData.zyxygdn || formData.zyxygdn === 0">
					<div class="item-header">
						<div class="item-title">总正向有功电能</div>
						<div class="update-time">{{formData.uploadTime || '-'}}</div>
					</div>
					<div class="item-value">{{formData.zyxygdn}}kwh</div>
				</div>
			</el-row>
			<!-- 无数据提示 -->
			<div class="no-data" v-if="!formData.dyldy && !formData.zdl && !formData.zyggl && !formData.zyxygdn">
				暂无电表实时数据
			</div>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'deviceDbView',
		props: {
		  id: {
		    required: true, // 必传设备ID，父组件弹窗传参
		    type: [Number, String],
		    default: 0
		  }
		},
	    data() {
		  return {
			  formData: {},  // 电表实时数据
			  formObject: {} // 设备基础信息
		  }
		},
		mounted() {
			// 确保ID存在再请求数据
			if(this.id) {
				this.infoView(this.id);
				this.loadData();
			} else {
				this.$Message.error("设备ID不能为空！");
			}
		},
		methods:{
			// 加载电表实时数据
			loadData(){
				let query = {deviceType:2,id:this.id,pageNum:1,pageSize:1} // deviceType=2 对应电表，修正原1的错误
				this.$request.post("/api/device/gf/db/page",query).then(response =>{
					if(response.data.result&&response.data.data!=null && response.data.data.list.length>0){
						this.formData = response.data.data.list[0];
					}else{
						this.$Message.warning("暂无电表实时数据！");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取电表数据失败！");
					console.error(err);
				})
			},
			// 加载设备基础信息
			infoView(id){
				this.$request.get('/api/device/info/'+id).then(response => {
					if(response.data.result){
						this.formObject = response.data.data;
					}else{
						this.$Message.error("获取设备信息失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取设备信息失败！");
					console.error(err);
				})	
			}
		}
	}
</script>

<!-- 移除scoped，让样式全局生效，覆盖ElementUI组件；和设备列表页面样式统一 -->
<style>
	/* 根容器：和设备列表统一的#001A33背景，满高适配弹窗 */
	.db-detail-root {
	  width: 100%;
	  height: calc(100vh - 120px);
	  padding: 20px;
	  background-color: var(--solar-page, #001A33) !important;
	  overflow-y: auto;
	}

	/* 设备基础信息卡片：#002B4D背景，蓝色边框，和搜索区统一 */
	.info-card {
	  width: 40%;
	  height: 200px;
	  background-color: var(--solar-surface, #002B4D) !important;
	  border: 1px solid var(--solar-border-strong, #0099FF) !important;
	  border-radius: 8px;
	  padding: 16px;
	  margin-bottom: 20px;
	}
	.info-header {
	  margin-top: 12px;
	  margin-left: 8px;
	}
	/* 设备图片/占位 */
	.device-img {
	  width: 90%;
	  height: 100px;
	  margin-top: 12px;
	  border-radius: 4px;
	  border: 1px solid var(--solar-border, #003C66);
	}
	.img-placeholder {
	  width: 90%;
	  height: 100px;
	  margin-top: 12px;
	  border-radius: 4px;
	  border: 1px dashed var(--solar-border-strong, #0099FF);
	  color: var(--solar-text, #87CEFA);
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  font-size: 14px;
	}
	/* 设备名称：浅蓝粗体，和表格表头统一 */
	.device-name {
	  font-size: 16px;
	  font-weight: 900;
	  color: var(--solar-text-strong, #B0E2FF) !important;
	  margin-bottom: 12px;
	}
	/* 信息行：标签+内容布局 */
	.info-row {
	  display: flex;
	  margin-top: 8px;
	  color: var(--solar-text, #87CEFA) !important;
	  font-size: 14px;
	}
	.label-col {
	  width: 120px;
	  color: var(--solar-text, #87CEFA) !important;
	}
	/* 设备状态色：和设备列表统一（离线红/在线浅蓝） */
	.status-online {
	  color: var(--solar-primary, #00CCFF) !important;
	  font-weight: 500;
	}
	.status-offline {
	  color: var(--solar-danger, #FF6666) !important;
	}
	.status-unknown {
	  color: var(--solar-muted, #6699CC) !important;
	}

	/* 电表数据卡片：#002B4D背景，蓝色边框，和信息卡片统一 */
	.data-card {
	  background-color: var(--solar-surface, #002B4D) !important;
	  border: 1px solid var(--solar-border-strong, #0099FF) !important;
	  border-radius: 8px;
	  padding: 20px 16px;
	}
	.data-row {
	  display: flex;
	  flex-wrap: wrap;
	}
	/* 单个数据项：#001A33背景，和表格行统一，间距适配 */
	.data-item {
	  width: calc((72vw - 53px)/4);
	  background-color: var(--solar-page, #001A33) !important;
	  border: 1px solid var(--solar-border, #003C66) !important;
	  border-radius: 8px;
	  margin-left: 12px;
	  margin-top: 12px;
	  padding: 12px;
	}
	/* 数据项头部：标题+更新时间 */
	.item-header {
	  display: flex;
	  margin-top: 4px;
	  margin-left: 12px;
	}
	.item-title {
	  font-weight: 900;
	  font-size: 14px;
	  color: var(--solar-text, #87CEFA) !important;
	}
	.update-time {
	  margin-left: auto;
	  margin-right: 10px;
	  font-size: 12px;
	  color: var(--solar-muted, #6699CC) !important;
	}
	/* 数据值：白色粗体，和表格高亮文字统一 */
	.item-value {
	  font-size: 30px;
	  font-weight: bolder;
	  margin-top: 20px;
	  text-align: center;
	  color: var(--solar-text-strong, #FFFFFF) !important;
	}
	/* 无数据提示：居中显示，浅蓝文字 */
	.no-data {
	  text-align: center;
	  padding: 50px 0;
	  color: var(--solar-text, #87CEFA) !important;
	  font-size: 16px;
	}

	/* 滚动条：和设备列表页面完全统一的蓝色样式 */
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: var(--solar-page, #001A33);
	}
	::-webkit-scrollbar-thumb {
		background-color: var(--solar-primary, #0099FF);
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background-color: var(--solar-surface, #002B4D);
		border-radius: 3px;
	}

	@media (max-width: 760px) {
		.db-detail-root {
			height: auto;
			min-height: 100%;
			padding: 0;
			overflow: visible;
		}

		.db-detail-root .info-card {
			width: 100%;
			height: auto;
			padding: 12px;
			margin-bottom: 12px;
		}

		.db-detail-root .info-header {
			display: flex;
			align-items: stretch;
			gap: 12px;
			margin: 0;
		}

		.db-detail-root .info-header > .el-col {
			width: 50%;
		}

		.db-detail-root .device-img,
		.db-detail-root .img-placeholder {
			width: 100%;
			height: 130px;
			margin-top: 0;
			object-fit: cover;
		}

		.db-detail-root .device-name {
			margin-bottom: 8px;
			font-size: 16px;
			line-height: 22px;
			overflow-wrap: anywhere;
		}

		.db-detail-root .info-row {
			min-width: 0;
			margin-top: 7px;
			font-size: 13px;
			line-height: 20px;
		}

		.db-detail-root .label-col {
			width: auto;
			flex: 0 0 auto;
		}

		.db-detail-root .info-row > .el-col:last-child {
			min-width: 0;
			overflow-wrap: anywhere;
		}

		.db-detail-root .data-card {
			display: grid;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 8px;
			padding: 8px;
		}

		.db-detail-root .data-card::before,
		.db-detail-root .data-card::after {
			display: none;
		}

		.db-detail-root .data-row {
			display: contents;
		}

		.db-detail-root .data-row::before,
		.db-detail-root .data-row::after {
			display: none;
			content: none;
		}

		.db-detail-root .data-item {
			width: auto;
			min-width: 0;
			margin: 0;
			padding: 10px;
		}

		.db-detail-root .item-header {
			min-width: 0;
			flex-direction: column;
			gap: 2px;
			margin: 0;
		}

		.db-detail-root .update-time {
			width: 100%;
			margin: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.db-detail-root .item-value {
			margin-top: 12px;
			font-size: 17px;
			line-height: 24px;
			overflow-wrap: anywhere;
		}

		.db-detail-root .no-data {
			grid-column: 1 / -1;
		}
	}

	@media (max-width: 420px) {
		.db-detail-root .info-header {
			flex-direction: column;
		}

		.db-detail-root .info-header > .el-col {
			width: 100%;
		}

		.db-detail-root .device-img,
		.db-detail-root .img-placeholder {
			height: 160px;
		}

	}
</style>
